export const sizes = {
  pageWidth: '100%',
  pageMinWidth: '765px',
  contentWidth: '635px',
  controlsWidth: '72px',
  orderWidth: '30px',
  blockPaddingX: '40px',
  blockPaddingY: '30px',
};

export const colors = {
  'charcoal-grey': '#29282e',
  'pale-grey': '#282324',
  'warm-grey-two': '#808080',
  'light-grey': '#d9d9d9',
  'pinkish-grey': '#cbcbcb',
  'dusty-orange': '#fd286f',
  algae: '#5df9a5',
  'cloudy-blue': '#a7c3d4',
  'off-blue': '#4f87a9',
  'black-six': '#fff',
  'white-four': '#f0f0f0',
  'white-five': '#fff',
  red: '#b90000',
};

export const cardColorScheme = {
  light: {
    backgroundColor: colors['white-five'],
    color: colors['black-six'],
    placeholderColor: colors['warm-grey-two'],
    opacity: 'rgba(255, 255, 255, 0.7)',
  },
  dark: {
    backgroundColor: colors['black-six'],
    color: colors['white-five'],
    placeholderColor: colors['pale-grey'],
    opacity: 'rgba(30, 30, 41, 0.7)',
  },
  tag: {
    backgroundColor: colors.red,
    color: colors['white-five'],
    placeholderColor: colors['pale-grey'],
    opacity: 'rgba(185, 0, 0, 0.7)',
  },
};

export const shadows = {
  paper: '0 2px 6px 0 rgba(35, 39, 48, 0.15)',
  list: '0 4px 8px 0 rgba(40, 40, 46, 0.1)',
};

export const placeholderColor = color => `
  .placeholder {
    color: ${color};
  }

  &::-webkit-input-placeholder {
    color: ${color};
    opacity: 1;
  }

  &::-moz-placeholder {
    color: ${color};
    opacity: 1;
  }

  &:-ms-input-placeholder {
    color: ${color};
    opacity: 1;
  }
`;

export const textBlock = colorScheme => (colorScheme && cardColorScheme[colorScheme] ? `
  color: ${cardColorScheme[colorScheme].color};
  background-color: ${cardColorScheme[colorScheme].backgroundColor};
  ${placeholderColor(cardColorScheme[colorScheme].placeholderColor)}
` : '');
